import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardGuard } from '../dashboard/guards/dashboard.guard';
import { AmountComponent } from './amount/amount.component';
import { ConfirmationComponent } from './confirmation/confirmation.component';
import { CustomComponent } from './custom/custom.component';
import { DesignComponent } from './design/design.component';
import { purchasePersistenceGuard } from './guards/purchase-persistence/purchase-persistence.guard';
import { MessageComponent } from './message/message.component';
import { PaymentComponent } from './payment/payment.component';
import { PurchaseComponent } from './purchase.component';
import { SendComponent } from './send/send.component';

const routes: Routes = [
    {
        path: '',
        component: PurchaseComponent,
        children: [
            {
                path: '',
                redirectTo: 'design',
                pathMatch: 'full',
            },
            {
                path: 'card',
                component: DesignComponent,
            },
            {
                path: 'tarjeta',
                component: DesignComponent,
            },
            {
                path: 'amount',
                component: AmountComponent,
                canActivate: [purchasePersistenceGuard],
            },
            {
                path: 'monto',
                component: AmountComponent,
                canActivate: [purchasePersistenceGuard],
            },
            {
                path: 'send',
                component: SendComponent,
                canActivate: [purchasePersistenceGuard],
            },
            {
                path: 'envio',
                component: SendComponent,
                canActivate: [purchasePersistenceGuard],
            },
            {
                path: 'payment',
                component: PaymentComponent,
                canActivate: [purchasePersistenceGuard, DashboardGuard],
            },
            {
                path: 'pago',
                component: PaymentComponent,
                canActivate: [purchasePersistenceGuard, DashboardGuard],
            },
            {
                path: 'message',
                component: MessageComponent,
                canActivate: [purchasePersistenceGuard],
            },
            {
                path: 'mensaje',
                component: MessageComponent,
                canActivate: [purchasePersistenceGuard],
            },
            {
                path: 'custom',
                component: CustomComponent,
                canActivate: [purchasePersistenceGuard],
            },
            {
                path: 'personaliza',
                component: CustomComponent,
                canActivate: [purchasePersistenceGuard],
            },
            {
                path: 'confirmation',
                component: ConfirmationComponent,
            },
            {
                path: 'confirmacion',
                component: ConfirmationComponent,
            },
        ],
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class PurchaseRoutingModule {}
